__turbopack_context__.v({
  "closeButton": "HeroCarousel-module__VhSYtG__closeButton",
  "hero-nav-pulse": "HeroCarousel-module__VhSYtG__hero-nav-pulse",
  "heroCarousel": "HeroCarousel-module__VhSYtG__heroCarousel",
  "playOverlay": "HeroCarousel-module__VhSYtG__playOverlay",
  "videoFloatingContainer": "HeroCarousel-module__VhSYtG__videoFloatingContainer",
  "videoOverlay": "HeroCarousel-module__VhSYtG__videoOverlay",
});
